import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import NavMenu from './NavMenu';
import NavMenuLeft from './NavMenuLeft';
import privacy from '../data/PrivacyNotice.pdf';

export default props => (
    <div>
        <NavMenu />
        <Container fluid>
            <Row>
                <Col xs="0">
                    <NavMenuLeft />
                </Col>
                <Col className="main">
                    {props.children}
                </Col>
            </Row>
            <Row>
                <Col>
                    <footer>
                        <p className="copyright">
                            Copyright &copy; 2020 HeartcoR Solutions, LLC. All rights reserved.
                            <br />
                            <a href={privacy}>Privacy Notice</a>
                        </p>
                    </footer>
                </Col>
            </Row>
        </Container>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Layout.js